export class ApiError extends Error {
  constructor(public readonly code: string, message: string, public readonly status: number) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`/v1${path}`, {
    ...init,
    credentials: "include",
    headers: {
      ...(init.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...init.headers
    }
  });
  const contentType = response.headers.get("content-type") ?? "";
  const payload = contentType.includes("application/json") ? await response.json() as Record<string, unknown> : null;
  if (!response.ok) {
    const error = payload?.error as { code?: string; message?: string } | undefined;
    throw new ApiError(error?.code ?? "REQUEST_FAILED", error?.message ?? "Não foi possível concluir.", response.status);
  }
  return payload as T;
}

export function post<T>(path: string, body: unknown, headers?: Record<string, string>) {
  return api<T>(path, { method: "POST", body: JSON.stringify(body), ...(headers ? { headers } : {}) });
}
